import { Input, ShowInfo, CitySelect, notify, ProgressBar } from '../utils';
import { FormProvider, useForm } from 'react-hook-form';
import { TextArea } from '../utils/TextArea';
import { prevStep, nextStep, ChangeStep } from '../redux/actions/StepperAction';
import { useEffect, useState, useRef, useCallback } from 'react';
import { getStatus, getUserInfo, sendUserInfo } from '../../api/MoadianService';
import { setCompleteInfo } from '../redux/actions/CompleteInfoAction';
import { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { setStatus } from '../redux/actions/TokneAction';
import { Box } from '@mui/material';
import { p2e } from "../methods/CommonMethods";
import { useNavigate } from 'react-router-dom';

export default function CompleteUserInfo() {

    const [userInfo, setUserInfo] = useState('')
    const [isSubmitted, setIsSubmitted] = useState(false)
    const tokenInfo = useSelector(state => state.Token)
    const [birthDate, setBirthDate] = useState('')
    const [disableSerial, setDisableSerial] = useState(false)
    const [progressTime, setProgressTime] = useState(0)
    const hasRequestedRef = useRef(false)
    const isRequestingRef = useRef(false)

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const methods = useForm();

    useEffect(() => {
        // Prevent multiple simultaneous calls or duplicate calls
        if (isRequestingRef.current || hasRequestedRef.current) {
            return;
        }

        isRequestingRef.current = true;
        hasRequestedRef.current = true;

        getUserInfo().then(response => {

            if (response?.data) {
                setUserInfo(response?.data)
                let dateToShow = response?.data.birthDate.slice(0, 4) + '/' + response?.data.birthDate.slice(4, 6) + '/' + response?.data.birthDate.slice(6);
                setBirthDate(dateToShow);
                methods.setValue("latinFirstName", response?.data?.latinFirstName ?? "");
                methods.setValue("latinLastName", response?.data?.latinLastName ?? "");
                methods.setValue("address", response?.data?.address ?? "");
                methods.setValue("postalCode", response?.data?.postalCode ?? "");
                methods.setValue("province", { label: response?.data?.province ?? "", value: response?.data?.province ?? "" });
                methods.setValue("city", { label: response?.data?.city ?? "", value: response?.data?.city ?? "" });
                methods.setValue("cardSerialNum", response?.data?.cardSerialNum ?? "");
            }
            isRequestingRef.current = false;
        }
        )
            .catch(error => {
                notify(error.response?.data?.message || 'خطا در دریافت اطلاعات')
                isRequestingRef.current = false;
                hasRequestedRef.current = false; // Allow retry on error
            })

        if (tokenInfo?.transactionId) {
            getStatus(tokenInfo.transactionId).then(response => {
                if (response?.data && response.data.transactionStatus == 'EKYC_DONE') {
                    setDisableSerial(true)
                    dispatch(setStatus({ status: response.data.transactionStatus }))
                }
            }).catch(error => console.warn(error.response?.data?.message))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {

        var timer = setInterval(() => {
            setProgressTime((oldProgress) => {
                if (oldProgress === 100) {
                    clearInterval(timer);
                    return 0;
                }
                const diff = 1;
                return Math.min(oldProgress + diff, 100);
            });
        }, 500);

        return () => clearInterval(timer);

    }, [])

    const onSubmit = methods.handleSubmit(data => {

        if (userInfo) {

            setIsSubmitted(true)
            const dataToSend = {
                ...data,
                province: data.province.value,
                city: data.city.value,
                latinFirstName: data.latinFirstName.replace(/\s/g, ''),
                latinLastName: data.latinLastName.replace(/\s/g, ''),
                cardSerialNum: data.cardSerialNum.replace(/\s/g, ''),
                postalCode: p2e(data.postalCode),
            }

            const dataOfCsr = {
                givenName: dataToSend.latinFirstName.replace(/\s/g, ''),
                surname: dataToSend.latinLastName.replace(/\s/g, ''),
                stateOrProvinceName: dataToSend.province,
                organizationName: 'Unaffiliated',
                serialNumber: userInfo?.nationalId,
                countryName: 'IR',
                commonName: dataToSend.latinFirstName + ' ' + dataToSend.latinLastName + ' [Sign]'
            }




            sendUserInfo(tokenInfo.transactionId, dataToSend).then(response => {

                dispatch(setCompleteInfo(dataOfCsr))

                if (response?.data?.statusCode === 2002) {

                    navigate('/fill-user-info')
                } else {
                    getStatus(tokenInfo.transactionId).then(response => {
                        if (response?.data && response.data.transactionStatus == 'EKYC_DONE') {
                            dispatch(ChangeStep(3));
                        } else {
                            dispatch(setStatus({ status: response.data.transactionStatus }))
                            dispatch(nextStep())
                        }
                    }).catch(error => console.warn(error.response.data.message))
                }

                setIsSubmitted(false)

            }).catch(error => {
                notify(error?.response?.data?.message)
                setIsSubmitted(false)
            })
        } else {
            notify("اطلاعات شما آپلود نشده است لطفا صفحه را مجددا به روز کنید.")
        }




    })


    const getGender = () => {
        if (userInfo?.gender == 'MALE') {
            return 'مرد'
        } else if (userInfo?.gender == 'FEMALE') {
            return 'زن'
        } else {
            return '-'
        }
    }

    return (
        <div>
            <Toaster />
            <ShowInfo
                title={'تکمیل اطلاعات'}
                message={'لطفا اطلاعات اولیه خود را با دقت وارد نمایید.'}
            />

            <div className='container my-4'>

                <div className='row justify-content-center  mt-3'>
                    <div className='col-12 col-md-5 border' style={{ "borderRadius": "10px" }}>
                        {userInfo ?
                            <>
                                <p className='complete-info-text my-2'>اطلاعات هویتی تایید شده</p>
                                <div className='complete-info-text-row py-2'>
                                    <span>کدملی</span>
                                    <span style={{ "color": "#38BAC4" }}>{userInfo?.nationalId}</span>
                                </div>

                                <div className='complete-info-text-row py-2'>
                                    <span>شماره موبایل</span>
                                    <span style={{ "color": "#38BAC4" }}>{userInfo?.phoneNumber}</span>
                                </div>

                                {/* <div className='complete-info-text-row py-2'>
                                    <span>جنسیت</span>
                                    <span style={{ "color": "#38BAC4" }}>{userInfo ? (getGender()) : ''}</span>
                                </div> */}

                                <div className='complete-info-text-row py-2'>
                                    <span>تاریخ تولد</span>
                                    <span style={{ "color": "#38BAC4" }}>{birthDate}</span>
                                </div>

                                {/* <div className='complete-info-text-row py-2'>
                                    <span>نام (فارسی)</span>
                                    <span style={{"color" : "#38BAC4"}}>{userInfo.firstName}</span>
                                </div>

                                <div className='complete-info-text-row py-2'>
                                    <span>نام خانوادگی (فارسی)</span>
                                    <span style={{"color" : "#38BAC4"}}>{userInfo.lastName}</span>
                                </div> 

                                <div className='complete-info-text-row py-2' style={{ "border": "none" }}>
                                    <span>نام پدر</span>
                                    <span style={{ "color": "#38BAC4" }}>{userInfo.fatherName}</span>
                                </div>
                                */}
                            </>
                            :
                            <Box sx={{ py: 3 }}>
                                <div className='text-center'>
                                    <img src={require('../../image/doc-wait.png')} className='my-5' alt='?' />
                                    <ProgressBar progress={progressTime} text={"در حال دریافت اطلاعات"} />
                                </div>

                            </Box>
                        }

                    </div>
                </div>
            </div>


            <FormProvider {...methods}>
                <form
                    onSubmit={e => e.preventDefault()}
                    noValidate
                    className="container"
                >

                    <Input
                        lable_text="نام(انگلیسی)"
                        type="text"
                        name="latinFirstName"
                        placeholder="First Name"
                        validation={{
                            required: {
                                value: true,
                                message: 'نام خود را به انگلیسی وارد کنید',
                            },
                            pattern: {
                                value: /^[A-Za-z\s]+$/,
                                message: 'لطفا فقط حروف انگلیسی وارد کنید',
                            },
                        }}
                        direction={'ltr'}
                    />

                    <Input
                        lable_text="نام خانوادگی(انگلیسی)"
                        type="text"
                        name="latinLastName"
                        placeholder="Last Name"
                        validation={{
                            required: {
                                value: true,
                                message: 'نام خانوادگی خود را به انگلیسی وارد کنید',
                            },
                            pattern: {
                                value: /^[A-Za-z\s]+$/,
                                message: 'لطفا فقط حروف انگلیسی وارد کنید',
                            },
                        }}
                        direction={'ltr'}
                    />

                    <CitySelect control={methods.control} watch={methods.watch} />

                    <TextArea
                        lable_text="آدرس محل اقامت"
                        type="text"
                        name="address"
                        placeholder="آدرس محل اقامت خود را وارد کنید"
                        validation={{
                            required: {
                                value: true,
                                message: 'آدرس محل اقامت خود را وارد کنید',
                            },
                        }}
                    />

                    <Input
                        lable_text="کد پستی محل اقامت"
                        type="text"
                        name="postalCode"
                        placeholder="کد پستی محل اقامت خود را وارد کنید"
                        validation={{
                            required: {
                                value: true,
                                message: ' کد پستی محل اقامت خود را وارد کنید.',
                            },
                            minLength: {
                                value: 10,
                                message: 'کد پستی شما صحیح نیست',
                            },
                        }}
                    />

                    <Input
                        lable_text="سریال پشت کارت ملی"
                        type="text"
                        name="cardSerialNum"
                        placeholder="سریال پشت کارت ملی خود را وارد کنید."
                        validation={{
                            required: {
                                value: true,
                                message: ' سریال پشت کارت ملی خود را وارد کنید.',
                            },
                            pattern: {
                                value: /^[0-9]{1}[a-zA-Z]{1}[0-9]{8}|[0-9]{8,}$/i,
                                message: 'سریال وارد شده صحیح نیست. برای وارد کردن سریال حتما کیبورد خود را انگلیسی کنید.'
                            },
                        }}
                        disable={disableSerial}
                    />

                    <div className='row justify-content-center my-3 mt-5'>

                        <div className='col-12 col-md-5 d-flex'>
                            <button
                                className='btn border text-form-title ms-2'
                                style={{ "padding": "1.5% 17%" }}
                                onClick={() => dispatch(prevStep())}
                            >بازگشت</button>

                            <button
                                onClick={onSubmit}
                                className='btn text-form-button me-2'
                                style={{ "background": "#044448", "padding": "1% 17%" }}
                            >ادامه</button>
                        </div>
                    </div>

                </form>
            </FormProvider>
            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}
        </div>

    )
}